import type { user } from "@/types/api/user.api";

export interface authState {
    user: user | null;
    accessToken: string | null;
    isLoading: boolean;
    isAuthenticated: boolean;
}

type authAction =
    | { type: "LOGIN"; payload: { user: user; accessToken: string } }
    | { type: "LOGOUT" }
    | { type: "UPDATE_USER"; payload: Partial<user> }
    | { type: "SET_LOADING"; payload: boolean };

export const initialState: authState = {
    user: null,
    accessToken: null,
    isLoading: true,
    isAuthenticated: false,
};

export const authReducer = (
    state: authState,
    action: authAction,
): authState => {
    switch (action.type) {
        case "LOGIN":
            return {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                user: action.payload.user,
                accessToken: action.payload.accessToken,
            };
        case "LOGOUT":
            return {
                ...state,
                user: null,
                accessToken: null,
                isLoading: false,
                isAuthenticated: false,
            };
        case "UPDATE_USER":
            return {
                ...state,
                user: state.user ? { ...state.user, ...action.payload } : state.user,
            };
        case "SET_LOADING":
            return {
                ...state,
                isLoading: action.payload,
            };
        default:
            return state;
    }
};
